import React, {useState} from "react"
import {AsyncResultModal} from "../../components/AsyncResultModal/AsyncResultModal"
import useAsyncResultIdle from "../../hooks/useAsyncResultIdle"
import {DepositAccount, FinancialBusinessFBOAccount, Wallet} from "../../resources/account"
import {useAccessToken} from "../../services/auth"
import {toCents} from "../../utilities/numbers"
import {createAccountHold} from "../../resources/accountHold"

interface CreateAccountHoldModalProps {
	account: DepositAccount | FinancialBusinessFBOAccount | Wallet
	closeModal: () => void
	onSuccess: () => void
}

function refreshAndClose(refresh: () => void, close: () => void) {
	return function () {
		refresh()
		close()
	}
}

export function CreateAccountHoldModal({account, closeModal, onSuccess}: CreateAccountHoldModalProps) {
	const accessToken = useAccessToken()
	const [amount, setAmount] = useState("0")
	const [expiredAt, setExpiredAt] = useState("")
	const [accountHold, setAccountHold] = useAsyncResultIdle(createAccountHold)

	const availableBalance = account.attributes.available / 100
	const numericAmount = parseFloat(amount)
	const isOverBalance = numericAmount > availableBalance
	const isValidAmount = !isNaN(numericAmount) && numericAmount > 0 && !isOverBalance

	return (
		<AsyncResultModal
			title="Create Balance Hold"
			close={refreshAndClose(onSuccess, closeModal)}
			buttonClassname="is-success"
			state={accountHold}
			buttonText="Place Account Hold"
			successText="Created"
			onSubmit={() => setAccountHold(accessToken, account.id, toCents(amount), expiredAt)}
			errorToText={(err) => err.errors[0].title}
			buttonDisabled={!isValidAmount}
		>
			<div className="account-hold-modal">
				<div className="form-row two">
					<div className="field">
						<label className="label">Hold Amount</label>
						<div className="control">
							<input
								className={`input ${isOverBalance ? "is-danger" : ""}`}
								type="number"
								min="0"
								step="0.01"
								value={amount}
								onChange={(e) => setAmount(e.target.value)}
							/>
							{isOverBalance && <p className="help is-danger">Amount is higher than available balance</p>}
						</div>
					</div>

					<div className="field">
						<label className="label">Available Balance</label>
						<div className="control">
							<input
								className="input"
								type="text"
								value={`$${(availableBalance - numericAmount).toFixed(2)}`}
								disabled
							/>
						</div>
					</div>
				</div>
				<div className="field expires">
					<label className="label">Expires at</label>
					<div className="control">
						<input className="input" type="date" value={expiredAt} onChange={(e) => setExpiredAt(e.target.value)} />
					</div>
				</div>
			</div>
		</AsyncResultModal>
	)
}
